/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { NavLink } from 'react-router-dom';
import Loading from '../../common/Loading';

import './index.scss';

Modal.setAppElement('#root');

class DeleteLayover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {};
  }

  closeModal() {
    this.props.deleteCampaignClose();
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.formresponse && nextProps.formresponse.deleteSuccess) {
      // this.closeModal();
      this.props.deleteCampaignClose(this.props.campaign);
    }
  };
  deleteCampaign = () => {
    this.props.DeleteCampaign({
      businessId: this.props.business.id,
      id: this.props.campaign.id,
      year_month: this.props.formresponse.formresponse.year_month,
    });
  };
  getServiceName = (service_id) => {
    if (this.props.formresponse && this.props.formresponse.servicelist) {
      return this.props.formresponse.servicelist[service_id];
    } else {
      return undefined;
    }
  };

  render() {
    const { modelopen, formresponse, campaign } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <div className="title">Are you sure?</div>
              <button className="modal-close" onClick={this.closeModal}>
                X
              </button>
              <div className="description">
                You are about to remove Lead Engage functionality from this
                campaign. By doing so, TrueLark will no longer respond to users
                submitting a form associated with this campaign. Deleting this
                campaign will also delete any reports associated with the
                campaign. Make sure you download any reports before you delete.
              </div>
              <div className="description">
                TrueLark also recommends removing the Lead Engage webhook from
                the associated form to avoid error messages from your form
                platform. Click{' '}
                <a
                  href="https://www.notion.so/Form-Response-disconnect-instructions-1648f01ed06141f4a470a3ff24eb8fc7"
                  target="_blank"
                >
                  here
                </a>{' '}
                to see how.
              </div>
              {formresponse.postDetails && (
                <div className="add-campaign_loader">
                  <Loading />
                </div>
              )}
              {campaign && (
                <div className="data-table">
                  <div className="data-header">
                    <div className="data-title">Campaign name</div>
                    <div className="data-title">Service</div>
                    <div className="data-title">Conversion rate</div>
                  </div>
                  <div className="data-footer">
                    <div className="data-title">{campaign.name}</div>
                    <div className="data-title">{campaign.service_name}</div>
                    <div className="data-title">
                      {campaign.conversion_rate}%
                    </div>
                  </div>
                </div>
              )}
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={this.deleteCampaign}
                  disabled={formresponse.postForm}
                >
                  {!formresponse.postForm ? 'DELETE' : 'Deleting'}
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={this.closeModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default DeleteLayover;
